module.exports = __webpack_public_path__ + "img/mission_background.6acf0d1.png";